import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Database, Download, Loader2 } from "lucide-react";
import { api } from "../lib/api";

// Admin card: Development Inventory skill library version + player-data backup download.
export function SkillLibraryCard() {
  const [meta, setMeta] = useState(null);
  const [arch, setArch] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.skillLibrary().then(d => setMeta({ version: d.version, active: d.active ?? (d.skills || []).filter(s => s.status === "active").length, total: (d.skills || []).length, synced_at: d.synced_at })).catch(() => setMeta(null));
    api.archetypeLibrary().then(d => setArch({ version: d.version, active: d.active ?? (d.archetypes || []).filter(a => a.status === "active").length })).catch(() => setArch(null));
  }, []);

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.downloadPlayerDataBackup();
      const name = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "player-data-backup.json";
      const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url);
      toast.success("Backup downloaded");
    } catch { toast.error("Could not download backup"); } finally { setBusy(false); }
  };

  return (
    <div className="border border-white/10 bg-[#1c1c1c] p-5 flex flex-wrap items-center gap-4" data-testid="skill-library-card">
      <Database className="w-5 h-5 text-[var(--org-accent)] shrink-0" />
      <div className="flex-1 min-w-[220px]">
        <div className="text-[10px] uppercase tracking-widest text-[#a0a0a0]">Development Inventory · Skill Library</div>
        <div className="text-white font-bold mt-0.5" data-testid="skill-library-version">
          {meta ? <>Library {meta.version} <span className="text-[#a0a0a0] font-normal">· {meta.active} active skills{meta.total > meta.active ? ` · ${meta.total - meta.active} retired` : ""}</span></> : "Library …"}
        </div>
        {arch && <div className="text-[11px] text-[#a0a0a0] mt-0.5" data-testid="archetype-library-version">Archetypes {arch.version} · {arch.active} active</div>}
        {meta?.synced_at && <div className="text-[10px] text-[#757575] mt-0.5">Synced {new Date(meta.synced_at).toLocaleString()} · source: backend/data/*.csv</div>}
      </div>
      <button onClick={download} disabled={busy} className="flex items-center gap-2 px-3 py-2 border border-white/20 text-white text-[10px] uppercase tracking-[0.3em] font-bold hover:border-[var(--org-accent)] hover:text-[var(--org-accent)] disabled:opacity-50" data-testid="download-player-backup-btn">
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Download className="w-3 h-3" />} Download player data backup
      </button>
    </div>
  );
}
